import { useMemo, useState } from "react"
import { Button, Table, Select, DatePicker, message, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: undefined | string,
    query_start_day: undefined | string,
    query_end_day: undefined | string,
    selectDate: any
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        selectDate: null,
        query_start_day: undefined,
        query_end_day: undefined,
    }

    // 设置对应的用户权限
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    const [loading, setLoading] = useState<boolean>(false)
    const [sumLoading, setSumLoading] = useState<boolean>(false)

    const [checkInList, setCheckInList] = useState<any>([])
    const [checkInSummary, setcheckInSummary] = useState<any>([])

    // 处理设置日期参数
    function onSetDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    // 设置搜索参数
    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    // 搜索
    const onSearch = () => {
        if (fetchOtherParams.selectDate) {
            fetchTableData(fetchOtherParams)

        } else {
            message.error('必须选择在住日期')
        }
    }

    // 请求汇总列表数据
    const fetchTableData = (fetchParams: any) => {
        let params: any = { ...fetchParams }

        onSetDate(params, 'selectDate', ['query_start_day', 'query_end_day'])
        params.store_id = (params.store_id && params.store_id.length) ? params.store_id.join(',') : undefined

        setLoading(true)
        setSumLoading(true)

        console.log(params, '请求参数')
        // 请求数据
        axiosTable.get('/keeper/data_report/month_check_in_per_summary/query_list', {
            params
        }).then((res: any) => {
            setLoading(false)
            setSumLoading(false)

            if (res) {
                const { month_check_in_list, month_check_in_summary } = res
                setCheckInList(month_check_in_list)

                let summaryArr = []
                month_check_in_summary.store_name = '全部门店'
                summaryArr.push(month_check_in_summary)

                setcheckInSummary(summaryArr)
            }

        }).catch((err: any) => {
            setLoading(false)
            setSumLoading(false)
        })
    }

    // 重置搜索条件
    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)
        fetchTableData(fetchOtherParamsTmpl)
    }

    // 导出
    const fetchExportData = () => {
        if (fetchOtherParams.selectDate) {
            let params: any = _.cloneDeep(fetchOtherParams)
            onSetDate(params, 'selectDate', ['query_start_day', 'query_end_day'])
            params.store_id = (params.store_id && params.store_id.length) ? params.store_id.join(',') : undefined

            // 请求导出数据
            baseAxiosComplete('/keeper/data_report/month_check_in_per_summary/export', {
                params
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })

        } else {
            message.error('必须选择在住日期')
        }
    }

    return (
        <div className="common-page">
            {/* 管家中心 -> 数据报表 -> 月入住率汇总表 */}
            <BreadCrumb position={['管家中心', '月入住率汇总表']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <div style={{ marginRight: 8, marginBottom: 12 }}>
                        {/* 门店多选 */}
                        <SelectStores
                            multiple
                            value={fetchOtherParams.store_id}
                            onChange={(v: string) => {
                                handleChange(v, 'store_id')
                            }}
                        />
                    </div>

                    {/* 选择日期 */}
                    <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 230 }}
                        placeholder={["开始日期", "结束日期"]}
                        value={fetchOtherParams.selectDate}
                        onChange={(v: any) => {
                            handleChange(v, 'selectDate')
                        }}
                    />
                </Space>

                <div style={{ marginTop: 10 }}>
                    {
                        permission.includes('查询') && (
                            <Button style={{ marginRight: 12, marginBottom: 12 }}
                                className="search-btn fl" icon={<SearchOutlined />}
                                onClick={() => { onSearch() }}>查询
                            </Button>
                        )
                    }
                    {/* 选择重置 */}
                    <Button
                        style={{ marginRight: 12, marginBottom: 12 }}
                        onClick={() => { resetForm() }}
                        icon={<RedoOutlined />}>重置
                    </Button>

                    {/* 报表导出 */}
                    {permission.includes('导出') && (
                        <Button
                            style={{ marginRight: 12, marginBottom: 12 }}
                            onClick={() => {
                                fetchExportData()
                            }}
                            type="dashed">导出
                        </Button>
                    )}
                </div>
            </div>

            <div className="common-main">
                <Table loading={loading} dataSource={checkInList} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
                    <Column title="门店" dataIndex="store_name" key="store_name" />
                    <Column title="房间数" dataIndex="room_count" key="room_count" />
                    <Column title="房间总天数" dataIndex="room_days" key="room_days" />
                    <Column title="空房天数" dataIndex="empty_days" key="empty_days" />
                    <Column title="空房率" dataIndex="empty_per" key="empty_per" />
                    <Column title="预定天数" dataIndex="reserve_days" key="reserve_days" />
                    <Column title="预订率" dataIndex="reserve_per" key="reserve_per" />
                    <Column title="入住天数" dataIndex="check_in_days" key="check_in_days" />
                    <Column title="入住率" dataIndex="check_in_per" key="check_in_per" />
                    <Column title="占用天数(预定+入住)" dataIndex="occupy_days" key="occupy_days" />
                    <Column title="占用率(预定+入住)" dataIndex="occupy_per" key="occupy_per" />
                </Table>
            </div>

            {/* 汇总 */}
            <div className="common-main">
                <h3>汇总</h3>
                <Table loading={sumLoading} dataSource={checkInSummary} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
                    <Column title="门店" dataIndex="store_name" key="store_name" />
                    <Column title="房间数" dataIndex="room_count" key="room_count" />
                    <Column title="房间总天数" dataIndex="room_days" key="room_days" />
                    <Column title="空房天数" dataIndex="empty_days" key="empty_days" />
                    <Column title="空房率" dataIndex="empty_per" key="empty_per" />
                    <Column title="预定天数" dataIndex="reserve_days" key="reserve_days" />
                    <Column title="预订率" dataIndex="reserve_per" key="reserve_per" />
                    <Column title="入住天数" dataIndex="check_in_days" key="check_in_days" />
                    <Column title="入住率" dataIndex="check_in_per" key="check_in_per" />
                    <Column title="占用天数(预定+入住)" dataIndex="occupy_days" key="occupy_days" />
                    <Column title="占用率(预定+入住)" dataIndex="occupy_per" key="occupy_per" />
                </Table>
            </div>
        </div>
    )
}